<template>

  <span>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'top'" class="tabs-shadow-none"
          id="profile-tabs" :key="isSmallerScreen">
          <vs-tab v-if="$canAny(['view-company-details-setting'])" icon-pack="feather" icon="icon-settings"
            :label="!isSmallerScreen ? 'General Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-8">
              <list-of-settings />
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny([
          'view-carriers-setting',
          'view-ccp-items-setting',
          'view-margin-costs-setting',
          'view-formulation-compositions-setting',
          'view-production-codes-setting',
          'view-raw-material-qc-test-setting',
          'view-shipping-costs-setting',
          'view-sundry-costs-setting',
          'view-work-order-manufacturing-setting',
          'edit-work-order-manufacturing-setting'
        ])" icon-pack="feather" icon="icon-cpu" :label="!isSmallerScreen ? 'Manufacturing Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <manufacturing-settings />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" v-if="$canAny([
          'view-communication-subjects-setting',
          'view-snapshot-vam-types-setting',
          'view-currency-setting',
          'view-customer-source-setting',
          'view-incoterms-setting',
          'view-user-type-setting',
          'view-pack-size-setting',
          'view-manage-reports-setting',
          'view-orders-additional-costs-setting',
          'view-sales-order-changes-reasons-setting',
          'view-tax-codes-setting',
          'view-so-lead-time-setting',
          'edit-so-lead-time-setting',
          'view-otif-target-setting',
          'edit-otif-target-setting'
        ])" icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Customer & Trading Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <customer-trading-settings />
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny([
          'view-holidays-setting',
          'view-staff-leaves',
          'view-manage-notifications-setting',
          'view-manage-reports-setting',
          'view-scheduled-task-templates',
          'view-company-address-setting',
          'edit-company-address-setting'
        ])" icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Staff & Business Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <staff-settings />
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny([
          'view-sage-nominal-code'
        ])" icon-pack="feather" icon="icon-home" :label="!isSmallerScreen ? 'SAGE Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <f-m-s-settings />
            </div>
          </vs-tab>
          <vs-tab v-if="$canAny([
          'view-raw-material-codes-setting'
        ])" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Supplier Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <supplier-settings />
            </div>
          </vs-tab>

        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>
import ManufacturingSettings from './ManufacturingSettings.vue';
import CustomerTradingSettings from './CustomerTradingSettings'
import StaffSettings from './StaffSettings.vue';
import FMSSettings from './FMSSettings.vue'
import SupplierSettings from './SupplierSettings.vue'
import ListOfSettings from './General/ListOfSettings'

export default {
  components: {
    ManufacturingSettings,
    CustomerTradingSettings,
    StaffSettings,
    FMSSettings,
    SupplierSettings,
    ListOfSettings,
  },
  data() {
    return {
      tab_mapping: {
        'general': 0,
        'manufacturing': 1,
        'customer_trading': 2,
        'staff': 3,
        'sage': 4,
        'supplier': 5,
      }
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    },
    active_step() {
      const tabParam = this.$route.query.tab;
      if (!tabParam) return 0;
      const tabValues = tabParam.split(' ');
      for (const tab of tabValues) {
        if (this.tab_mapping[tab]) {
          return this.tab_mapping[tab];
        }
      }
      return 0;
    }
  },
  methods: {}
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
